"use client"

import { t } from "@/languages/i18n"
import { CaretDownOutlined, CaretUpOutlined } from "@ant-design/icons"
import { Button, Space, Typography } from "antd"
import React, { useState } from "react"
import { PublishProps } from "../../../../lib/config/types"
import { LanguagePublish, StatusPublish, VisibilityPublish } from "./StatusPublish"

const { Title } = Typography

const Publish: React.FC<PublishProps> = ({
  onSubmit,
  isCreateEdit,
  setStatus,
  status,
  setPublishDate,
  language,
  setLanguages,
}) => {
  const [isPublishListVisible, setPublishListVisible] = useState(true)

  return (
    <div className="publish border-gray-300 border rounded-[10px] mb-5 ">
      <div className="flex justify-between items-center px-4 py-3 border-b">
        <Title level={4} className="!m-0">
          {t("Publish")}
        </Title>
        <Button
          onClick={() => setPublishListVisible(!isPublishListVisible)}
          className="flex items-center"
          icon={isPublishListVisible ? <CaretDownOutlined /> : <CaretUpOutlined />}
          type="text"
        />
      </div>

      {isPublishListVisible && (
        <div>
          <Space direction="vertical" className="px-4 py-4">
            <StatusPublish setStatus={setStatus} status={status} />
            <LanguagePublish language={language} setLanguages={setLanguages} isCreateEdit={isCreateEdit} />
            <VisibilityPublish />
          </Space>
          <div className="flex justify-end border-t bg-[#f6f7f7] rounded-b-[10px]">
            <div className="px-4 py-3">
              <Button type="primary" onClick={onSubmit}>
                {status.match("Draft") ? t("Save Draft") : isCreateEdit ? t("Publish") : t("Update")}
              </Button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default Publish
